import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { OfflineHeadset } from 'src/models';
import { RootState } from 'src/store';
import { headsetsSelectors } from 'src/store/reducers/offlineHeadsets';

export const useOfflineHeadsetsState = (): RootState['offlineHeadsets'] => {
  const state = useSelector<RootState, RootState['offlineHeadsets']>(
    (state) => state.offlineHeadsets,
  );

  useDebugValue(state);

  return state;
};

export const useOfflineHeadsets = (): OfflineHeadset[] => {
  const state = useSelector<RootState, RootState['offlineHeadsets']>(
    (state) => state.offlineHeadsets,
  );

  const headsets = headsetsSelectors.selectAll(state);

  useDebugValue(headsets);

  return headsets;
};
